import React, { useEffect, useState } from 'react';
import { mixGetV2, mixPostV2, formatNumber, mixPostV1, mixGetV1, mixHisStatus } from '../../services/mixin';
import Layout from '../../Layout';
import { Input, Pagination, Select, Tag, DatePicker } from 'antd';
import { UploadOutlined, EyeOutlined, SettingOutlined } from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';
import './PoolingDateCustomerListHistoryImport .scss';
import { Link, useNavigate } from 'react-router-dom';
import useToast from '../../hook/useToast';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';

import MegaTable from '../../components/MagaTableV2';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { selectorSourceColumnWarehouse } from '../../store/slices/sourceColumnWarehouseSlice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

const getDefaultPagination = () => ({ current: 1, pageSize: 10, total: 0 });

const CustomerList: React.FC = () => {
  const pushToast = useToast();
  const navigate = useNavigate()
  const sourceColumnWarehouse = useSelector(selectorSourceColumnWarehouse);
  const user = useSelector(selectorInfoUser);
  // State
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.history_syndata_crm?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCachePoolingDateCustomerListHistoryImport',
    col: [
      {
        headerName: 'Hành động',
        field: 'action',
        width: 100,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
          return (
            <div className='list-action-icon'>
              <Link className='action-ctr' to={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.id}`}>
                <EyeOutlined />
              </Link>
            </div>
          )
        },
      },
      {
        headerName: 'Trạng thái đồng bộ',
        field: 'status',
        cellRenderer: (params: any) => {
          return (
            <div>
              <Tag color={mixHisStatus(params.data.status).color}>
                {mixHisStatus(params.data.status).title}
              </Tag>
            </div>
          )
        }
      },
      ...tableColumns(sourceColumnWarehouse),
    ],
    listData: [],
    selectedRowKeys: [],
    isRowsSelect: false,
    clearRowSelect: false,
    showSetting: false,
    loading: true,
  });
  const [pagination, setPagination] = useState(getDefaultPagination());
  const [defaultKeyword, setDefaultKeyword] = useState<string>('');
  const [paramListData, setParamListData] = useState<any>({
    'sort[]': 'created_at,desc',
    page: 1,
    limit: 10,
    search: '',
    status: null,
    start_day: null,
    end_day: null,
    user_id: null,
  });

  // Search
  const { Search } = Input;
  const onSearch: SearchProps['onSearch'] = (value) => {
    setParamListData((prev: any) => ({
      ...prev,
      search: value,
      page: 1,
      limit: pagination.pageSize
    }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const getListData = async () => {
    setMegaTableData((prev: any) => ({ ...prev, loading: true }));
    const res = await mixGetV2('/api/v1/be/history_back_customers_crm', {
      ...paramListData
    })
    setMegaTableData((prev: any) => ({ ...prev, loading: false }));
    if (res.status) {
      const temp = [] as any;
      res.data.items.forEach((val: any) => {
        temp.push({
          ...val,
          key: val.id,
        })
      });
      setMegaTableData((prev: any) => ({ ...prev, listData: temp }));
      setPagination((prev) => ({ ...prev, total: res.data.total }));
    }
  }

  useEffect(() => {
    getListData();
  }, [paramListData]);

  // useEffect(() => {
  //   const sampleData = [
  //     {
  //       id: 1,
  //       key: 1,
  //       warehouse_id_origin: 'WH001',
  //       cus_name: 'Nguyễn Văn A',
  //       cus_tel: '0901234567',
  //       cus_email: 'a.nguyen@gmail.com',
  //       cus_marital_status: 'Độc thân',
  //       cus_scope: 'VIP',
  //       cus_lifecycle_status: 'Khách hàng mới',
  //       cus_business_field: 'Bán lẻ',
  //       cus_tax_reg_no_dms: '123456789',
  //       cus_route_name: 'Điểm bán 1',
  //       cus_branch_name: 'Chi nhánh 1',
  //       cus_gender_name: 'Nam',
  //       cus_group_name: 'Nhóm A',
  //       cus_type_name: 'Cá nhân',
  //       cus_code: 'CUS001',
  //       cus_address: '123 Đường ABC, Quận 1',
  //       cus_ward: 'Phường 1',
  //       cus_city: 'TP.HCM',
  //       cus_note: 'Khách hàng tiềm năng',
  //       cus_interest: 'Ô tô',
  //       cus_channels_name: 'Website',
  //       cus_recent_care_staff: 'NV001',
  //       cus_birth_day: '01-01-1990',
  //       cus_dms_id_card_no: '012345678',
  //       cus_career_name: 'Kinh doanh',
  //       cus_updated_at: '10-11-2025',
  //       cus_created_at: '01-10-2025',
  //       cus_sync_status: 1,
  //     },
  //     {
  //       id: 2,
  //       key: 2,
  //       warehouse_id_origin: 'WH002',
  //       cus_name: 'Trần Thị B',
  //       cus_tel: '0912345678',
  //       cus_email: 'b.tran@gmail.com',
  //       cus_marital_status: 'Đã kết hôn',
  //       cus_scope: 'Thường',
  //       cus_lifecycle_status: 'Khách hàng cũ',
  //       cus_business_field: 'Dịch vụ',
  //       cus_tax_reg_no_dms: '987654321',
  //       cus_route_name: 'Điểm bán 2',
  //       cus_branch_name: 'Chi nhánh 2',
  //       cus_gender_name: 'Nữ',
  //       cus_group_name: 'Nhóm B',
  //       cus_type_name: 'Doanh nghiệp',
  //       cus_code: 'CUS002',
  //       cus_address: '456 Đường XYZ, Quận 2',
  //       cus_ward: 'Phường 2',
  //       cus_city: 'Hà Nội',
  //       cus_note: '',
  //       cus_interest: 'Xe máy',
  //       cus_channels_name: 'App',
  //       cus_recent_care_staff: 'NV002',
  //       cus_birth_day: '15-05-1985',
  //       cus_dms_id_card_no: '876543210',
  //       cus_career_name: 'Nhân viên văn phòng',
  //       cus_updated_at: '09-11-2025',
  //       cus_created_at: '15-09-2025',
  //       cus_sync_status: 2,
  //     },
  //     // Có thể thêm nhiều dòng hơn
  //   ];

  //   setMegaTableData((prev: any) => ({
  //     ...prev,
  //     listData: sampleData,
  //     loading: false,
  //   }));
  //   setPagination((prev) => ({ ...prev, total: sampleData.length }));
  // }, []);

  const handleChangePagination = (page: number, pageSize: number): void => {
    setParamListData((prev: any) => ({ ...prev, page, limit: pageSize }));
    setPagination((prev) => ({ ...prev, current: page, pageSize }));
  };

  const [dasData, setDasData] = useState({
    total_success: 0,
    total_fail: 0,
  } as any)
  let wait1 = false
  const getDasData = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2('/api/v1/be/seting?key=dashboard_customer_history_back_crm')
    wait1 = false
    if (res.status) {
      setDasData(res.data ? JSON.parse(res.data.value || '{}') : {})
    }
  }

  let wait3 = false
  const [listStaff, setListStaff] = useState<any>([])
  const getListStaff = async () => {
    if (wait3) {
      return
    }
    wait3 = true
    const res = await mixGetV1('apiChild/listStaff');
    wait3 = false
    if (res.status) {
      setListStaff(res.data || [])
    }
  }

  useEffect(() => {
    getDasData()
    getListStaff()
  }, [])


  return (
    <>
      <Layout className='customer-list'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link> },
            { title: 'Khách hàng' },
            { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link> },
            { title: 'Lịch sử danh sách khách hàng được đưa vào CRM' },
          ]}
          title={`Lịch sử danh sách khách hàng được đưa vào CRM`}
          backLink='/customer/pooling-data'
          className='gutter-block-end'
        />

        <div className="his-total-list">
          <div className="his-one-item" style={{ backgroundImage: 'url("/images/bg-item.svg")' }}>
            <div className="title">Tổng KH đã đồng bộ</div>
            <div className="count">{formatNumber(dasData.total_success + dasData.total_fail)}</div>
          </div>
          <div className="his-one-item" style={{ backgroundImage: 'url("/images/bg-item.svg")', borderColor: '#F59C23' }}>
            <div className="title">Thành công</div>
            <div className="count">{formatNumber(dasData.total_success)}</div>
          </div>
          {/* <div className="his-one-item" style={{ backgroundImage: 'url("/images/bg-item.svg")' }}>
            <div className="title">Chờ đồng bộ</div>
            <div className="count">5.000</div>
          </div> */}
          <div className="his-one-item" style={{ backgroundImage: 'url("/images/bg-item.svg")', borderColor: '#F59C23' }}>
            <div className="title">Thất bại</div>
            <div className="count">{formatNumber(dasData.total_fail)}</div>
          </div>
        </div>

        {/* Filter block */}
        <div className={`filter-block ${megaTableData.selectedRowKeys.length ? "active" : ""}`}>
          <div className='v4 v2 w-100'>
            <div className='t-search-block'>
              <Search value={paramListData.search} placeholder="Tìm kiếm" onChange={(e) => {
                onSearch(e.target.value)
              }} />
            </div>

            <RangePicker
              popupClassName="t-ctrl-date-picker"
              className='rs-date-picker v2'
              format="DD/MM/YYYY"
              allowClear
              placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
              onChange={(date, dateString) => {
                console.log(date, dateString);
                setParamListData((prev: any) => ({
                  ...prev,
                  start_day: dateString[0] ? dayjs(dateString[0], 'DD/MM/YYYY').format('YYYY/MM/DD') : null,
                  end_day: dateString[1] ? dayjs(dateString[1], 'DD/MM/YYYY').format('YYYY/MM/DD') : null,
                  page: 1
                }));
                setPagination((prev) => ({ ...prev, current: 1 }));
              }}
            />
            <Select
              className='rs-select v2'
              placeholder='Trạng thái đồng bộ'
              allowClear
              options={mixHisStatus().map((status: any) => ({ label: status.title, value: status.value }))}
              value={paramListData.status}
              onChange={(value) => {
                setParamListData((prev: any) => ({ ...prev, status: value, page: 1 }));
                setPagination((prev) => ({ ...prev, current: 1 }));
              }}
            />
            <Select
              className='rs-select v2'
              placeholder='Nhân viên'
              showSearch
              allowClear
              options={listStaff.map((staff: any) => ({ label: staff.username, value: staff.id }))}
              value={paramListData.user_id}
              filterOption={(input, option) => {
                const normalize = (s: any) =>
                  String(s ?? '')
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .replace(/đ/g, 'd')
                    .replace(/Đ/g, 'D')
                    .toLowerCase()

                const label = option?.label ?? option?.children ?? option?.value ?? ''
                return normalize(label).includes(normalize(input))
              }}
              onChange={(value) => {
                setParamListData((prev: any) => ({ ...prev, user_id: value, page: 1 }));
                setPagination((prev) => ({ ...prev, current: 1 }));
              }}
            />
          </div>

          <div className="btn-input t-px-8" onClick={() => { setMegaTableData((prev: any) => ({ ...prev, showSetting: true })) }}>
            <div className="icon-svg"><SettingOutlined /></div>
          </div>
        </div>
        <MegaTable
          stData={{ ...megaTableData }}
          stChange={(data) => {
            setMegaTableData((prev: any) => ({ ...prev, ...data }));
          }}
        />

        <div className="t-table-block t-table-customer c-table-scoll-x">
          <div className="pagination-block">
            <Pagination
              className='rs-pagination'
              showSizeChanger
              total={pagination.total}
              pageSize={pagination.pageSize}
              current={pagination.current}
              pageSizeOptions={['10', '20', '50', '100']}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={() => `Tổng cộng ${Math.ceil(pagination.total / pagination.pageSize) === 0 ? 1 : Math.ceil(pagination.total / pagination.pageSize)} trang`}
              locale={{ items_per_page: 'trang' }}
              onChange={handleChangePagination}
            />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CustomerList;
